<template>
  <div class="report-container">
    <div class="fixed-header">
      <UploadFile :reportId="id" :isUploadZx="isUploadZx" @reloadDetail="getDetail" />
      <div class="topheader">
        <div class="qyname">
          <div class="back-icon" @click="goBack" v-show="true">
            <span class="back-arrow"></span>
          </div>
          <span class="company-name">{{ nsrmc }}</span>
        </div>
        <div class="qylable">
          <div>高新技术企业</div>
          <div>科技型中小企业</div>
          <div>专精特新中小企业</div>
        </div>
        <van-tabs v-model="active" color="#ffffff">
          <van-tab title="基本信息"></van-tab>
          <van-tab title="个人征信"></van-tab>
          <van-tab title="企业征信"></van-tab>
          <van-tab title="企业贷后"></van-tab>
          <van-tab title="个人贷后"></van-tab>
        </van-tabs>
      </div>
    </div>

    <div class="content-wrapper">
    <div class="detailView">
      <div v-if="active === 0">
        <van-empty v-if="!basicWord || !basicWord.startsWith('http')" description="暂无基本信息" />
        <RecognizeInfo v-else :detail="basicWord" />
      </div>
      <div v-if="active === 1">
        <van-empty v-if="resultData.personageStatus != 2" :description="gerenMessage" />
        <RecognizeInfo v-else :detail="gerenWord" />
      </div>
      <div v-if="active === 2">
        <van-empty v-if="resultData.firmStatus != 2" :description="qiyeMessage" />
        <RecognizeInfo v-else :detail="qiyeWord" />
      </div>
      <div v-if="active === 3">
        <CustomerManage :reportRecordId="id" :showHomeButton="false" :loan-type="1"/>
      </div>
      <div v-if="active === 4">
        <CustomerManage :reportRecordId="id" :showHomeButton="false" :loan-type="0"/>
      </div>
    </div>
    </div>

    <!-- 首页按钮 -->
    <div 
      class="home-button" 
      @click="goToHome"
    >
      <van-icon name="wap-home" size="16" />
    </div>

  </div>
</template>

<script>
import request from "@/utils/request";
import RecognizeInfo from "./components/RecognizeInfo.vue"
import UploadFile from "./components/UploadFile.vue"
import CustomerManage from "../customer/index.vue"

export default {
  components: {
    RecognizeInfo,
    UploadFile,
    CustomerManage
  },
  props: {
    activeTab: {
      type: Number,
      default: 0,
    },
    id: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      active: 0,
      resultData: {
        id: "",
      },
      gerenMessage: "",
      qiyeMessage: "",
      isUploadZx: false,
      nsrmc: "",
      basicWord: null,
      qiyeWord: null,
      gerenWord: null,
      // 拖动相关变量
      isDragging: false,
      startX: 0,
      startY: 0,
      currentX: 0,
      currentY: 0,
    }
  },
  mounted() {
    // 初始化按钮位置
    this.initButtonPosition();
  },
  created() {
    this.active = this.activeTab;
    this.getDetail();
  },
  methods: {
    getDetail() {
      let self = this;
      request.get("/Data/ReportTask/GetReportRecord", { params: { id: this.id } }).then((res) => {
        // console.log(res);
        let dataResult = res.data.data;
        self.resultData = res.data.data;
        self.nsrmc = res.data.data.enterpriseName;
        // self.getGrQyWord(dataResult.id)
        self.basicWord = res.data.data.medusaUrl;
        self.qiyeWord = res.data.data.firmPTPUrl;
        self.gerenWord = res.data.data.personagePTPUrl;

        try {
          if (dataResult) {
            if (dataResult.personageStatus === 0) {
              self.gerenMessage = "未上传个人征信信息"
            }
            if (dataResult.personageStatus === 1) {
              self.gerenMessage = "个人征信信息识别中";
            }

            if (dataResult.firmStatus === 0) {
              self.qiyeMessage = "未上传企业征信信息";
            }
            if (dataResult.firmStatus === 1) {
              self.qiyeMessage = "企业征信信息识别中";
            }

            if (dataResult.firmStatus === 2 && dataResult.personageStatus === 2) {
              self.isUploadZx = true;
            }
          } else {
            let message = "";
            // // 跳转到
            if (dataResult.status === 0) {
              message = "报告正在生成中，请耐心等待！"
            } else if (dataResult.status === 2) {
              message = "报告已作废，暂无法查看！"
            } else {
              message = "获取报告失败！"
            }

            self.$router.push("/callbackResult?t=" + message);
            // setTimeout(() => {
            //   wx.redirectTo({
            //     url: '../result/index?message=' + message,
            //   })
            // }, 100)
          }
        } catch (message) {
          console.log("获取企业报告失败：" + message);
        }
      })
    },
    getGrQyWord(id) {
      // 个人/企业征信
      let self = this;
      request.get("/Data/ReportTask/GetPTPResult", { params: { id: id } }).then((res) => {
        // console.log(res);
        try {
          if (res.data) {
            if (res.data.data.firmResult) {
              let data = JSON.parse(res.data.data.firmResult);
              console.log(data);
              self.qiyeWord = data;
            } else {
              self.qiyeWord = false;
            }
            if (res.data.data.personageResult) {
              let data = JSON.parse(res.data.data.personageResult);
              // console.log(data);
              self.gerenWord = data;
            } else {
              self.gerenWord = false;
            }
          } else {
            self.qiyeWord = false;
            self.gerenWord = false;
          }
        } catch (err) {
          console.error(err)
        }
      })
    },
    // 返回首页
    goToHome() {
      this.$router.push("/credit/home");
    },
    // 返回上一页
    goBack() {
      this.$router.back();
    },
    // 开始拖动
    startDrag(e) {
      this.isDragging = true;
      // 处理鼠标和触摸事件
      const clientX = e.clientX || e.touches[0].clientX;
      const clientY = e.clientY || e.touches[0].clientY;
      this.startX = clientX - this.currentX;
      this.startY = clientY - this.currentY;
    },
    // 拖动中
    drag(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      // 处理鼠标和触摸事件
      const clientX = e.clientX || e.touches[0].clientX;
      const clientY = e.clientY || e.touches[0].clientY;
      this.currentX = clientX - this.startX;
      this.currentY = clientY - this.startY;
      // 限制在可视区域内
      const button = this.$refs.homeButton;
      if (button) {
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        const buttonWidth = button.offsetWidth;
        const buttonHeight = button.offsetHeight;
        // 限制水平范围
        this.currentX = Math.max(0, Math.min(windowWidth - buttonWidth, this.currentX));
        // 限制垂直范围
        this.currentY = Math.max(0, Math.min(windowHeight - buttonHeight, this.currentY));
        // 设置按钮位置
        button.style.left = `${this.currentX}px`;
        button.style.top = `${this.currentY}px`;
      }
    },
    // 结束拖动
    endDrag() {
      this.isDragging = false;
      // 自动靠到最近的边上
      this.autoSnapToEdge();
    },
    // 初始化按钮位置
    initButtonPosition() {
      const button = this.$refs.homeButton;
      if (button) {
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        const buttonWidth = button.offsetWidth;
        const buttonHeight = button.offsetHeight;
        
        // 默认停在右下角
        this.currentX = windowWidth - buttonWidth - 10;
        this.currentY = windowHeight - buttonHeight - 90;
        
        button.style.left = `${this.currentX}px`;
        button.style.top = `${this.currentY}px`;
      }
    },
    // 自动靠到最近的左边或右边
    autoSnapToEdge() {
      const button = this.$refs.homeButton;
      if (button) {
        const windowWidth = window.innerWidth;
        const buttonWidth = button.offsetWidth;
        
        // 计算按钮中心坐标
        const centerX = this.currentX + buttonWidth / 2;
        
        // 计算到左右边的距离
        const distanceToLeft = centerX;
        const distanceToRight = windowWidth - centerX;
        
        // 确定最近的水平边
        let newX;
        if (distanceToLeft < distanceToRight) {
          // 靠左
          newX = 10;
        } else {
          // 靠右
          newX = windowWidth - buttonWidth - 10;
        }
        
        // 保持当前垂直位置
        const newY = this.currentY;
        
        // 更新位置
        this.currentX = newX;
        this.currentY = newY;
        button.style.left = `${newX}px`;
        button.style.top = `${newY}px`;
      }
    },
  }
}
</script>

<style lang="less" scoped>
.report-container {
  background-color: #fff;
  min-height: 100vh;
  -webkit-background-color: #F0F4FF;
  background: #F0F4FF;
}

.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: #176FCA;
}

.content-wrapper {
  padding-top: 210px;
  background-color: #F0F4FF;
  min-height: calc(100vh - 210px);
}

.topheader {
  overflow: hidden;
  background: #176FCA;
  margin-top: -1px;
}

.report-container > div:first-child {
  background: #176FCA;
}

.qyname {
  font-size: 1.2rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: .5rem;
  margin-left: 5px;
  margin-top: .4rem;
  margin-bottom: .8rem;
  height: 32px;
}

.company-name {
  line-height: 32px;
}

.back-icon {
  cursor: pointer;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  position: relative;
  z-index: 10;
  flex-shrink: 0;
}

.back-arrow {
  display: inline-block !important;
  width: 10px;
  height: 10px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(45deg);
  margin-right: 4px;
  visibility: visible !important;
  opacity: 1 !important;
}

.qycode {
  font-size: .8rem;
  color: #fff;
  padding-left: .8rem;
  margin-top: .8rem;
}

.qylable {
  display: flex;
  justify-content: center;
  gap: .8rem;
  margin: .5rem 0 .8rem;
}

.qylable div {
  font-size: .6rem;
  color: #fff;
  display: inline-block;
  border-radius: .5rem;
  padding: 0 .5rem;
  line-height: 1rem;
  border: solid 1px #6FA6DE;
  background: #458BD5;
}

.detailView {
  padding-bottom: 5rem;
}

.home-button {
  position: fixed;
  right: 20px;
  bottom: 30px;
  z-index: 999;
  width: 45px;
  height: 45px;
  background-color: #176FCA;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: background-color 0.3s;
}

.home-button:hover {
  background-color: #145EAB;
}

/* 确保 van-tabs 背景色与顶部一致 */
.report-container ::v-deep .van-tabs,
.report-container ::v-deep .van-tabs__wrap,
.report-container ::v-deep .van-tabs__nav,
.report-container ::v-deep .van-tabs__nav--line {
  background-color: #176FCA !important;
}

.report-container ::v-deep .van-hairline--top-bottom {
  border: none !important;
}

.report-container ::v-deep .van-tabs__nav {
  border: none !important;
}

:deep(.van-tab) {
  color: rgba(255, 255, 255, 0.8) !important;
}

:deep(.van-tab--active) {
  color: #fff !important;
  font-weight: 500;
}

:deep(.van-tabs__line) {
  background-color: #fff !important;
}
</style>

<style lang="less">
/* 非 scoped 样式强制覆盖 van-tabs 背景 */
.report-container .van-tabs,
.report-container .van-tabs__wrap,
.report-container .van-tabs__nav,
.report-container .van-tabs__nav--line {
  background-color: #176FCA !important;
}
.report-container .van-hairline--top-bottom {
  border: none !important;
}
.report-container .van-tab {
  color: #C1D3E9 !important;
}
.report-container .van-tab--active {
  color: #fff !important;
}
</style>